/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "group-select": {
      "placeholder": "Search by group name"
    }
  },
  "de-DE": {
    "group-select": {
      "placeholder": "Nach Gruppenname suchen"
    }
  },
  "es-ES": {
    "group-select": {
      "placeholder": "Buscar por nombre de grupo"
    }
  },
  "fr-FR": {
    "group-select": {
      "placeholder": "Chercher par nom de groupe"
    }
  },
  "id-ID": {
    "group-select": {
      "placeholder": "Cari berdasarkan nama grup"
    }
  },
  "it-IT": {
    "group-select": {
      "placeholder": "Cerca per nome gruppo"
    }
  },
  "jp-JP": {
    "group-select": {
      "placeholder": "グループ名で検索"
    }
  },
  "ko-KO": {
    "group-select": {
      "placeholder": "그룹 이름으로 검색"
    }
  },
  "nl-NL": {
    "group-select": {
      "placeholder": "Zoeken op groepsnaam"
    }
  },
  "pl-PL": {
    "group-select": {
      "placeholder": "Wyszukaj według nazwy"
    }
  },
  "pt-PT": {
    "group-select": {
      "placeholder": "Pesquisar por nome de grupo"
    }
  },
  "ru-RU": {
    "group-select": {
      "placeholder": "Поиск по имени группы"
    }
  },
  "tr-TR": {
    "group-select": {
      "placeholder": "Grup adına göre ara"
    }
  },
  "vi-VN": {
    "group-select": {
      "placeholder": "Tìm kiếm theo tên nhóm"
    }
  },
  "zh-CN": {
    "group-select": {
      "placeholder": "按群组名称搜索"
    }
  },
  "zh-TW": {
    "group-select": {
      "placeholder": "依群組名稱搜尋"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
